import React, { useEffect, useContext, useState } from "react";
import { Stack, Flex, Box, Text, VisuallyHidden, ControlBox, Icon, Divider, Skeleton } from "@chakra-ui/core";

const LoadingFoodOptions = () => {
  return (
    <Box pt={0}>
      <Box bg="gray.50" w="full" mb="4" px="6" py="4">
        <Skeleton height={5} my={2} w={40} />
        <Skeleton height={4} mt={1} w={64} />
      </Box>
      <Stack variantColor="green" w="full" px="6" mb={4} mt={1}>
        {/* RENDER RADIO INPUTS */}
        {[1, 2, 3].map((item, j) => {
          return (
            <React.Fragment key={j}>
              {j !== 0 && <Divider />}
              <Skeleton height={6} my={1} w="full" />
            </React.Fragment>
          );
        })}
      </Stack>
    </Box>
  );
};

export default LoadingFoodOptions;
